import { createIcon } from '@chakra-ui/react';

const ToolkitIcon = createIcon({
  displayName: 'OnPremise',
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        d="M8.24269 0H0.776697C0.349514 0 0 0.349514 0 0.776697V8.24269C0 8.66988 0.349514 9.01939 0.776697 9.01939H8.24269C8.66988 9.01939 9.01939 8.66988 9.01939 8.24269V0.776697C9.01939 0.349514 8.66988 0 8.24269 0ZM7.466 7.466H1.55339V1.55339H7.466V7.466Z"
        fill="white"
      />
      <path
        d="M19.2234 0H11.7574C11.3302 0 10.9807 0.349514 10.9807 0.776697V8.24269C10.9807 8.66988 11.3302 9.01939 11.7574 9.01939H19.2234C19.6506 9.01939 20.0001 8.66988 20.0001 8.24269V0.776697C20.0001 0.349514 19.6506 0 19.2234 0ZM18.4467 7.466H12.5341V1.55339H18.4467V7.466Z"
        fill="white"
      />
      <path
        d="M8.24269 10.9805H0.776697C0.349514 10.9805 0 11.33 0 11.7572V19.2232C0 19.6503 0.349514 19.9999 0.776697 19.9999H8.24269C8.66988 19.9999 9.01939 19.6503 9.01939 19.2232V11.7572C9.01939 11.33 8.66988 10.9805 8.24269 10.9805ZM7.466 18.4465H1.55339V12.5339H7.466V18.4465Z"
        fill="white"
      />
      <path
        d="M19.2234 10.9805H11.7574C11.3302 10.9805 10.9807 11.33 10.9807 11.7572V19.2232C10.9807 19.6503 11.3302 19.9999 11.7574 19.9999H19.2234C19.6506 19.9999 20.0001 19.6503 20.0001 19.2232V11.7572C20.0001 11.33 19.6506 10.9805 19.2234 10.9805ZM18.4467 18.4465H12.5341V12.5339H18.4467V18.4465Z"
        fill="white"
      />
    </>
  ),
});

export default ToolkitIcon;
